import { useCallback, useEffect, useState } from 'react';
import WorkFileService from '../../services/WorkFileService';
import { conversionLine } from '../work/workFolderUi';

/** New Dubbing Audio at Audio conversion (6d): who sees it and the latest run. */
const useTaskConversion = ({ open, detail, load }) => {
    const [conversion, setConversion] = useState(null);
    const task = detail?.task;
    const hasDubbingAudio = task?.contentType === 'VIDEO' || task?.contentType === 'AUDIO';
    const atAudioConversion =
        !!task && !task.redacted && hasDubbingAudio && task.currentStageKey === 'AUDIO_CONVERSION';

    const loadConversion = useCallback(() => {
        if (!atAudioConversion) {
            setConversion(null);
            return Promise.resolve(null);
        }
        return WorkFileService.conversion(task.id)
            .then((v) => {
                setConversion(v);
                return v;
            })
            .catch(() => {
                setConversion(null);
                return null;
            });
    }, [atAudioConversion, task?.id]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        loadConversion();
    }, [loadConversion]);

    // While it runs, look again every 10 seconds; when it ends, reload so the folder and History show the result
    const converting = conversion?.latest?.status === 'PROCESSING';
    useEffect(() => {
        if (!converting || !open) return undefined;
        const timer = setInterval(() => {
            loadConversion().then((v) => {
                if (v && v.latest?.status !== 'PROCESSING') load();
            });
        }, 10000);
        return () => clearInterval(timer);
    }, [converting, open, loadConversion, load]);
    const convertLine = conversionLine(conversion?.latest, task?.languageLabel);
    // Audio conversion completes only once the language's shared folder has the dubbing audio
    const needsDubbingAudio = atAudioConversion && !!detail?.workFolder && !detail.workFolder.dubbingAudio;

    return { conversion, converting, convertLine, loadConversion, atAudioConversion, needsDubbingAudio };
};

export default useTaskConversion;
